import React, { useEffect, useState } from 'react';
import { SubPageShell } from '../App';
import { allServices } from '../mock';
import { TickList, ContactPromptCard } from '../components/SharedUI';

export default function ServicesPage() {
  const [openService, setOpenService] = useState(null);
  useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'auto' });
}, []);
  return (
    <SubPageShell kicker="04 — Full Services" title={<>Things I can build for you.</>}>
      <div className="section" style={{ paddingTop: 40 }}>
        <p style={{ color: 'rgba(245,245,245,0.6)', maxWidth: 720, fontSize: 16, lineHeight: 1.7, marginTop: 0 }}>
          Posters of every kind &mdash; events, clubs, movies, gym, food, brand, festival, even meme posters &mdash; designed for very, very cheap. Plus content writing, websites,
          edits, thumbnails, and project assistance. Pick anything below or message me with your idea.
        </p>

        <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 20 }}>
          {allServices.map((s) => (
           <div 
            
              key={s.id}
                  className={`glass-card service-mobile-card ${openService === s.id ? 'service-open' : ''}`}
                  onClick={() => setOpenService(openService === s.id ? null : s.id)}
              style={{
                padding: 32,
                display: 'grid',
                gridTemplateColumns: '120px minmax(0, 1.3fr) minmax(0, 1fr)',
                gap: 32,
                alignItems: 'flex-start',
              }}
            >
              <div
                className="mono"
                style={{
                  fontSize: 36,
                  fontFamily: 'Anton, sans-serif',
                  color: 'rgba(245,245,245,0.4)',
                  letterSpacing: '0.05em',
                }}
              >
                {s.code}
              </div>
              <div>
                <h3 style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 500, fontSize: 28, margin: 0, letterSpacing: '-0.01em' }}>
                  {s.title}
                </h3>
                <p style={{ color: 'rgba(245,245,245,0.65)', fontSize: 14.5, lineHeight: 1.7, marginTop: 12 }}>
                  {s.desc}
                </p>
              </div>
              <div>
                <div
                  className="mono"
                  style={{
                    fontSize: 10,
                    letterSpacing: '0.3em',
                    color: 'rgba(245,245,245,0.5)',
                    textTransform: 'uppercase',
                    marginBottom: 12,
                  }}
                >
                  / Includes
                </div>
                <TickList items={s.perks} />
              </div>
            </div>
          ))}
        </div>

        <ContactPromptCard message="Need something not listed? Just message me — I probably do it." />
      </div>
    </SubPageShell>
  );
}
